/* global modForm */
/**
 * Mark field is invalid
 * @param {Object} $field - field to mark as invalid
 * @returns {boolean} - false if no field provided
 */
export function markFieldAsInvalid($field) {
	if (!$field) {
		return false;
	}
	const fieldParent = $field.parentElement.closest('.' + modForm.opts.errorParentCls);
	if (fieldParent) {
		fieldParent.classList.add(modForm.opts.fieldErrorCls);
		if (modForm.opts.addAccessibilityUpdates) {
			if ($field.getAttribute('type') === 'radio') {
				const radioFieldsetId = $field.closest('fieldset').getAttribute('id');
				const $firstRadio = $field.closest('fieldset').querySelector('input[type="radio"]:first-child');
				$firstRadio.setAttribute('aria-invalid', 'true');
				$firstRadio.setAttribute('aria-describedby', 'error--' + radioFieldsetId);
				$firstRadio.focus();
			} else {
				let fieldId;
				if ($field.hasAttribute('id')) {
					fieldId = $field.getAttribute('id');
				} else {
					fieldId = $field.getAttribute('name');
				}
				$field.setAttribute('aria-invalid', 'true');
				$field.setAttribute('aria-describedby', 'error--' + fieldId);
			}
		}
	} else {
		$field.parentElement.classList.add(modForm.opts.fieldErrorCls);
	}

	// Check if auto height is enabled and force update the height of the swiper once errors are shown
	if (modForm.opts.formSwiperInstance && modForm.opts.formSwiperInstance.params.autoHeight === true) {
		modForm.opts.formSwiperInstance.updateAutoHeight();
	}
}
